import Vue from "vue";
import Router from "vue-router";
import auth from "./auth/authService";

Vue.use(Router);
const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            component: () => import("./layouts/application.vue"),
            children: [
                {
                    path: "/",
                    component: () => import("./views/home/index.vue"),
                },
                {
                    path: "/welcome",
                    component: () => import("./views/welcome/index.vue"),
                },
                {
                    path: "/login",
                    component: () => import("./views/auth/login.vue"),
                },
                {
                    path: "/firebase",
                    component: () => import("./views/firebase/index.vue"),
                },
                {
                    path: "/error-404",
                    component: () => import("./views/errors/404.vue"),
                },
                {
                    path: "/error-500",
                    component: () => import("./views/errors/500.vue"),
                },

                // ------------------------------
                // account page
                // ------------------------------
                {
                    path: "/account",
                    component: () => import("./views/account/index.vue"),
                },
                // {
                //     path: "/account/profile",
                //     component: () => import("./views/account/profile.vue"),
                // },
                // {
                //     path: "/account/security",
                //     component: () => import("./views/account/security.vue"),
                // },
                // {
                //     path: "/account/billing",
                //     component: () => import("./views/account/billing.vue"),
                // },
                // {
                //     path: "/account/notifications",
                //     component: () => import("./views/account/notifications.vue"),
                // },

                // ------------------------------
                // product page
                // ------------------------------
                // {
                //     path: "/products",
                //     component: () => import("./views/products/index.vue"),
                // },
                {
                    path: "/products/:id/checkout",
                    component: () => import("./views/products/checkout.vue"),
                },

                // ------------------------------
                // order page
                // ------------------------------
                {
                    path: "/orders",
                    component: () => import("./views/orders/index.vue"),
                },
                {
                    path: "/orders/:orderId",
                    component: () => import("./views/orders/detail.vue"),
                },
                {
                    path: "/orders/:orderId/payment",
                    component: () => import("./views/orders/payment/index.vue"),
                },
                {
                    path: "/orders/:orderId/payment/completed",
                    component: () =>
                        import("./views/orders/payment/completed.vue"),
                },
                {
                    path: "/orders/:orderId/payment/failed",
                    component: () =>
                        import("./views/orders/payment/failed.vue"),
                },
                {
                    path: "/orders/:orderId/contact",
                    component: () => import("./views/orders/contact.vue"),
                },

                // {
                //     path: "/admin/products/create",
                //     component: () => import("./views/products/create.vue"),
                // },

                // {
                //     path: "/admin/products",
                //     component: () => import("./views/products/index.vue"),
                // },

                // {
                //     path: "/admin/products/:id/edit",
                //     component: () => import("./views/products/edit.vue"),
                // },
            ],
        },
        {
            path: "*",
            component: () => import("./views/errors/404.vue"),
        },
    ],
});

router.afterEach(() => {
    // console.log("router afterEach");
});

router.beforeEach((to, from, next) => {
    const isAuthenticated = auth.isAuthenticated();

    // console.log("isAuthenticated", isAuthenticated);

    const guardPaths = ["/welcome", "/login", "/error-404", "/error-500"];
    if (guardPaths.includes(to.path)) {
        if (isAuthenticated) {
            router.push({ path: "/" });
        }

        return next();
    }

    if (!isAuthenticated) {
        router.push({ path: "/welcome" });
    }

    return next();
});

export default router;
